<template>
	<div class="popup" @click="handleClose">
		<div class="popup-item">
			<span @click="handleClose" class="close">
				<svg
					width="20"
					height="20"
					viewBox="0 0 20 20"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<g clip-path="url(#clip0_3587_2637)">
						<path
							d="M19.7636 0.237119C19.4481 -0.0783887 18.9366 -0.0783887 18.6211 0.237119L0.236875 18.6213C-0.0786328 18.9368 -0.0786328 19.4483 0.236875 19.7638C0.39461 19.9217 0.601407 20.0005 0.808164 20.0005C1.01492 20.0005 1.22168 19.9216 1.37945 19.7638L19.7636 1.37962C20.0791 1.06415 20.0791 0.552627 19.7636 0.237119Z"
							fill="#E9407A"
						/>
						<path
							d="M19.7636 18.6208L1.37938 0.236631C1.06391 -0.0788769 0.552344 -0.0788769 0.236875 0.236631C-0.0786328 0.552099 -0.0786328 1.06362 0.236875 1.37913L18.6211 19.7633C18.7788 19.9211 18.9856 20 19.1924 20C19.3991 20 19.6059 19.9211 19.7636 19.7634C20.0791 19.4478 20.0791 18.9363 19.7636 18.6208Z"
							fill="#E9407A"
						/>
					</g>
				</svg>
			</span>
			<div class="popup-item-inner">
				<div class="character">
					<div class="character-inner">
						<img src="../../../../assets/characher.png" alt="Character" />
					</div>
				</div>
				<p class="title">
					{{
						(type !== 'PUZZLE_OPEN'
							? 'The puzzle is open!'
							: 'Congratulations!') | translate
					}}
				</p>
				<p class="text">
					{{
						(type !== 'PUZZLE_OPEN' ? 'You get it' : 'You get the task done')
							| translate
					}}
				</p>
				<p class="point">
					{{ type === 'PUZZLE_OPEN' ? '3i$' : '1i$' }}
				</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['cancel', 'type'],
	name: 'PuzzleModal',
	methods: {
		handleClose(e) {
			this.$emit('close')
		},
	},
}
</script>

<style lang="scss" scoped>
.popup {
	z-index: 999;
	position: fixed;
	right: 0;
	left: 0;
	top: 0;
	bottom: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	background-color: rgba(#000, 0.7);

	&-item {
		background-color: #fff;
		min-width: 570px;
		border-radius: 40px;
		padding: 4px;
		background-image: url('../../../../assets/back-white.png');
		background-position: bottom;
		background-size: contain;
		position: relative;

		&-inner {
			padding: 0 30px 30px;
			border-radius: 36px;
			border: 2px dashed #e9407a;
		}

		@media (max-width: 768px) {
			min-width: 100%;
			width: 100%;
		}
	}

	.character {
		margin-left: auto;
		margin-right: auto;
		width: 120px;
		height: 120px;
		border-radius: 10em;
		display: flex;
		justify-content: center;
		align-items: center;
		background-color: var(--orange-color);
		padding: 4px;
		transform: translateY(-50%);

		&-inner {
			width: 100%;
			height: 100%;
			border-radius: 10em;
			display: flex;
			justify-content: center;
			align-items: center;
			border: 2px dashed #ffffff;

			img {
				width: 100%;
				max-width: 80px;
			}
		}
	}

	.title {
		color: var(--violet-color);
		margin-top: -30px;
		text-align: center;
		font-weight: 700;
		font-size: 24px;
		line-height: 28px;
		border-bottom: 4px solid #e6e9f3;
		margin-bottom: 20px;
		padding-bottom: 20px;
	}

	.text {
		color: var(--pink-color);
		text-align: center;
		font-weight: 400;
		font-size: 20px;
		line-height: 22px;
	}

	.point {
		text-align: center;
		color: var(--pink-color);
		font-weight: 700;
		font-size: 80px;
		line-height: 140%;
	}

	.close {
		width: 40px;
		border-radius: 10em;
		background-color: #e6e9f3;
		height: 40px;
		display: flex;
		justify-content: center;
		align-items: center;
		right: 20px;
		top: 20px;
		position: absolute;
		opacity: 1;
	}
}
</style>
